module.exports = __webpack_public_path__ + "img/model2.b652aab5.png";